/**
 * Boards of area (b) — clients. OWNED BY area (b) — clients (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const clientsBoards: BoardDef[] = [
  {
    id: "Admin-Dashboard",
    ref: "134",
    title: "Cabinet compta — Tableau de bord",
    area: "clients",
    path: "/compta",
    href: "/compta",
    permission: ["cabinet.dashboard", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.dashboard",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Dashboard")),
  },
  {
    id: "Admin-Clients",
    ref: "135",
    title: "Cabinet compta — Clients",
    area: "clients",
    path: "/compta/clients",
    href: "/compta/clients",
    permission: ["cabinet.clients", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Clients")),
  },
  {
    id: "Admin-Client-Fiche",
    ref: "136",
    title: "Cabinet compta — Fiche client — Atelier Roux",
    area: "clients",
    path: "/compta/clients/$companyId",
    href: "/compta/clients/cmp_atelier_roux",
    permission: ["cabinet.clients", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Client-Fiche")),
  },
  {
    id: "Admin-Onboardings",
    ref: "135b",
    title: "Cabinet compta — Clients en onboarding",
    area: "clients",
    path: "/compta/onboardings",
    href: "/compta/onboardings",
    permission: ["cabinet.clients", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    note: "Onglet « En onboarding » de Clients.",
    component: lazy(() => import("./boards/Admin-Onboardings")),
  },
  {
    id: "Admin-Onboarding-Dossier",
    ref: "141b",
    title: "Cabinet compta — Onboarding d'un client",
    area: "clients",
    path: "/compta/onboardings/$companyId",
    href: "/compta/onboardings/cmp_boulangerie_ines",
    permission: ["cabinet.clients", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    note: "Fiche miroir, phases 1 et 2 (Inès : étape SIRET ; les autres états dans les scénarios « (b) »).",
    component: lazy(() => import("./boards/Admin-Onboarding-Dossier")),
  },
  {
    id: "Admin-Onboarding-Etapes",
    ref: "141c",
    title: "Cabinet compta — Onboarding d'un client (suite)",
    area: "clients",
    path: "/compta/onboardings/$companyId",
    href: "/compta/onboardings/cmp_boulangerie_ines?phase=3",
    permission: ["cabinet.clients", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    note: "Même fiche, ?phase=3 : phases 3 et 4 (lettre, paiement, activation, démarrage).",
    component: lazy(() => import("./boards/Admin-Onboarding-Etapes")),
  },
  {
    id: "Admin-Prospects",
    ref: "141d",
    title: "Cabinet compta — Prospects",
    area: "clients",
    path: "/compta/prospects",
    href: "/compta/prospects",
    permission: ["cabinet.prospects", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    note: "Onglet « Prospects » de Clients.",
    component: lazy(() => import("./boards/Admin-Prospects")),
  },
  {
    id: "Admin-Prospect-Fiche",
    ref: "141e",
    title: "Cabinet compta — Fiche prospect",
    area: "clients",
    path: "/compta/prospects/$prospectId",
    href: "/compta/prospects/prs_cafe_lumiere",
    permission: ["cabinet.prospects", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Prospect-Fiche")),
  },
];
